import { GUEST_EVENTS_LEAD_FEED } from '../../../Constants'

interface GetGuestEventsURLArgs {
  lfAccessSecret: string
  showSuccess: boolean
}

const getGuestEventsURL = ({ lfAccessSecret, showSuccess }: GetGuestEventsURLArgs): URL => {
  const queryParams = new URLSearchParams({
    ...(showSuccess && { 'brief-success': 'true' }),
    accessSecret: lfAccessSecret,
  })
  const gexpURL = new URL(GUEST_EVENTS_LEAD_FEED)
  gexpURL.search = queryParams.toString()

  return gexpURL
}

export default getGuestEventsURL
